import { Typography, Box, Stack, Divider } from "@mui/material";
import moment from "moment";
import {capitalizeWords} from "../../../../utils/utils"

const StepStatus = {
    0: "Submitted",
    1: "Submitted",
    2: "Completed",
    3: "Rejected",
};

const StepStatusColor = {
    0: "#6B7280", // gray-600
    1: "#F59E0B", // yellow-500
    2: "#16A34A", // green-600
    3: "#DC2626", // red-600
};

const formatDate = (date) => moment(date).format("DD MMM YYYY, hh:mm A");

// Reusable info block component
const InfoBlock = ({ label, value, date }) => (
    <Stack spacing={0.5} mb={1.5}>
        <Typography variant="caption" color="text.secondary">
            {label}
        </Typography>
        <Typography variant="body2" fontWeight={500}>
            {value}
        </Typography>
        {date && (
            <Typography variant="caption" color="text.disabled" fontStyle="italic">
                {formatDate(date)}
            </Typography>
        )}
        <Divider />
    </Stack>
);

export const RenderTooltipContent = (details,name) => {
    if (!details) return "";

    const {
        partially_approved_by_name,
        approved_by_name,
        rejected_by_name,
        partially_approved_at,
        submitted_by_name,
        completed_by_name,
        completed_at,
        approved_at,
        rejected_at,
        submitted_at,
        reason,
        comment,
        status,
    } = details;

    return (
        <Box
            sx={{
                minWidth: 240,
                p: 2,
                backgroundColor: "#f9fafb",
                borderRadius: 2,
                boxShadow: 4,
                border: '1px solid #e5e7eb',
            }}
        >
            <Typography fontWeight="bold" fontSize={14} mb={2}>
                {name}&nbsp;:&nbsp;
                <Box component="span" sx={{ color: StepStatusColor[status] }}>
                    {StepStatus[status]}
                </Box>
            </Typography>
           {submitted_by_name && (
                <InfoBlock
                    label="Submitted By"
                    value={capitalizeWords(submitted_by_name)}
                    date={submitted_at}
                />
            )}
            {partially_approved_by_name && (
                <InfoBlock
                    label="Submitted By"
                    value={capitalizeWords(partially_approved_by_name)}
                    date={partially_approved_at}
                />
            )}
            {completed_by_name && (
                <InfoBlock
                    label="Completed By"
                    value={capitalizeWords(completed_by_name)}
                    date={completed_at}
                />
            )}
            {approved_by_name && (
                <InfoBlock
                    label="Completed By"
                    value={capitalizeWords(approved_by_name)}
                    date={approved_at}
                />
            )}


            {rejected_by_name && (
                <InfoBlock
                    label="Rejected By"
                    value={capitalizeWords(rejected_by_name)}
                    date={rejected_at}
                />
            )}

            {reason && (
                <Stack spacing={0.5}>
                    <Typography variant="caption" color="text.secondary">
                        Reason
                    </Typography>
                    <Typography variant="body2" fontWeight={500}>
                        {reason}
                    </Typography>
                    {comment && (
                        <Typography variant="caption" color="text.disabled" fontStyle="italic">
                            {comment}
                        </Typography>
                    )}
                </Stack>
            )}
        </Box>
    );
};
   